export default __webpack_public_path__ + "static/media/not_free_join_as_member_loyalty_bk.20e6aea1.png";